<template>
  <div class="content">
    <p class="strong">十九大报告为医改领域描绘了新的蓝图</p>
    <h4>王虎峰</h4>
    <p>一、十九大报告做出的重大论断和新时期的目标任务指明了医改的前进方向</p>
    <p>十九大报告开宗明义，提出了“为中国人民谋幸福，为中华民族谋复兴”的奋斗目标，同时做出了我国仍处于重要战略机遇期的战略判断，提出要“勇于变革、勇于创新”，同时分析了“当前的主要矛盾转化为人民日益增长的美好生活需要和不平衡不充分的发展之间的矛盾”，提出了实现现代化和中华民族伟大复兴的目标，并且提出了两个阶段的发展规划：从2020到2035年，为第一个阶段，这个阶段其中一项重要任务就是基本公共服务均等化；2035年到本世纪中叶为第二个阶段，建成富强民主文明和谐美丽的社会主义现代化强国，提出“使人民享有更加幸福安康的生活”。以上这些重要的论断同医改工作密切相关。这些论断和战略部署预示着医改将作为我们抓住战略机遇、勇于变革、勇于创新的一个重要的战略组成，也是化解主要矛盾的重要构成，同时还是两个发展阶段当中重要的指标性内容，因此，也可以说十九大为医改领域描绘了新的发展蓝图。</p>
    <p>二、十九大报告丰富和完善了中国特色的民生体系</p>
    <p>从党的十六大第一次提出来“民生”概念，再到党的十八大逐步构建了以教育、就业和再就业、社会保障、收入分配和医疗为主要构成的民生体系，十九大报告对此进行了进一步的丰富和完善。报告构建了涵盖“教育、就业和收入、社会保障、脱贫、健康中国建设”这样一个具有更加丰富内涵的民生体系，使得中国特色的民生工程内容更加丰富，包括医改在内的健康中国建设已经成为了我国民生体系的重要组成部分。</p>
    <p>三、十九大报告对全面实施健康中国战略有了更高的定位和要求</p>
    <p>党的十八大以来，我们提出了健康国家建设的战略目标，把健康中国建设上升为国家战略，把健康置于优先发展的位置，提出了“没有全民健康，就没有全面小康”。十九大报告在此基础上进一步提出了“人民健康是民族昌盛和国家富强的重要标志”的论断，提出“实施健康中国战略。要完善国民健康政策，为人民群众提供全方位全周期健康服务。”这是一个重大的标志。意味着健康中国战略是我们国之大计，各行各业、社会各界，都应贯彻将健康融入所有政策的方针，将健康同各领域、各方面的工作相结合。健康中国战略具有更加深刻的内涵和更加重要的战略地位。</p>
    <p>四、十九大报告强调深化医药卫生体制改革进一步向制度化建设迈进</p>
    <p>（一）报告首次提出了“三个制度一个体系”。这就是 “全面建立中国特色基本医疗卫生制度、医疗保障制度”、“健全现代医院管理制度”和“优质高效的医疗卫生服务体系”。这段话突出了全面建立这个重点，这与十八大以来强调推进试点形成一个显著的对照，医改已经由试点阶段进行了制度构建阶段，更加注重于制度性建设和体系性改进。</p>
    <p>（二）对医改领域的表述有了新的逻辑和亮点。首先，报告在明确制度建设后，专门提到加强基层医疗卫生体系建设和全科医生队伍建设；然后依次提到了药品保障、预防为主，食品安全，中西医并重，社会办医和健康产业，最后又提出了生育政策和人口战略以及人口老龄化的应对政策。这些论述对于解决医改领域的重点问题做了统筹谋划和安排</p>
    <p>（三）对医改领域的论述具有重大的政策涵义。这些论述其内在的政策涵义是更加重视供给侧结构性改革，对医疗服务体系，特别是基层的建设放在了重中之重的位置；更加强调效率，在医疗卫生体系前面加上了优质高效的限定词；把食品安全放在了更加重要的位置，“让人民吃得放心”成为健康的重要组成部分；对于人口以及生育政策和老龄化的应对政策更加积极，预示了人口政策将和其他社会经济政策相关联、和社会经济发展相关联、和产业发展相关联。从总体上看，医改在社会经济领域、乃至政治领域的地位作用会越来越重要。</p>
  </div>
</template>

<script>
export default {
  name: 'TabMedicalReform'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  .strong{
    color: #000000;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 18px;
    text-align: center;
  }
  h4{
    color: #666;
    font-weight: bold;
    text-align: center;
    margin: 20px;
  }
  p{
    line-height: 36px;
    text-indent: 40px;
  }
}
</style>
